// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P"};